import * as React from 'react'
import { cn } from '@/lib/utils'

export type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement>

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(({ className, ...props }, ref) => (
  <select
    className={cn(
      'flex h-8 w-full border border-[#222] bg-[#0d0d0d] px-3 py-1 text-[11px] font-mono text-[#e8e8e8] focus:outline-none focus:ring-1 focus:ring-[#00ff88] focus:border-[#00ff88] disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer transition-colors appearance-none',
      className
    )}
    ref={ref}
    {...props}
  />
))
Select.displayName = 'Select'
export { Select }
